// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"navbar_searchIcon__2ZNoB","hideOnSmall":"navbar_hideOnSmall__1exV7","hideOnLg":"navbar_hideOnLg__2SOTZ"};